import { Col, Row } from 'antd'

import { FormItem } from '@eastcoal/formily/components/FormItem'
import { Input } from '@eastcoal/formily/components/Input'
import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'
import { TextArea } from '@eastcoal/formily/components/TextArea'

import { OcrBusinessLicense } from '@eastcoal/shared/@formily/OcrBusinessLicense'
import { OcrIdCard } from '@eastcoal/shared/@formily/OcrIdCard'

export const businessLicenseSchema: Record<string, SchemaItem> = {
  [`
  { 
    ossId: licenseOssId, 
    result: {
        creditCode,
        companyName,
        companyType,
        businessScope,
        businessAddress,
        legalPerson,
        registeredCapital,
        validPeriod,
        RegistrationDate: registrationDate
      }
  }
  `]: {
    title: '营业执照',
    type: 'object',
    'x-decorator': FormItem,
    'x-component': OcrBusinessLicense
  },
  companyName: {
    title: '企业名称',
    type: 'string',
    'x-pattern': 'readPretty',
    'x-decorator': FormItem,
    'x-component': Input
  },
  creditCode: {
    title: '统一社会信用代码',
    type: 'string',
    'x-pattern': 'readPretty',
    'x-decorator': FormItem,
    'x-component': Input
  },
  legalPerson: {
    title: '法人',
    type: 'string',
    'x-pattern': 'readPretty',
    'x-decorator': FormItem,
    'x-component': Input
  },
  companyType: {
    title: '企业类型',
    type: 'string',
    'x-decorator': FormItem,
    'x-component': Input
  },
  businessAddress: {
    title: '企业住所',
    type: 'string',
    'x-decorator': FormItem,
    'x-component': Input
  },
  businessScope: {
    title: '经营范围',
    type: 'string',
    'x-decorator': FormItem,
    'x-component': TextArea
  },
  registrationDate: {
    title: '成立日期',
    type: 'string',
    'x-decorator': FormItem,
    'x-component': Input
  },
  registeredCapital: {
    title: '实缴资本',
    type: 'string',
    'x-decorator': FormItem,
    'x-component': Input
  },
  validPeriod: {
    title: '营业期限',
    type: 'string',
    'x-pattern': 'readPretty',
    'x-decorator': FormItem,
    'x-component': Input
  },
  companyNameAbbr: {
    title: '企业简称',
    type: 'string',
    'x-decorator': FormItem,
    'x-component': Input
  },
  legalPersonRow: {
    title: '法人身份证',
    type: 'void',
    'x-decorator': FormItem,
    'x-decorator-props': {
      wrapperWidth: 'auto',
      asterisk: true,
      feedbackLayout: 'none'
    },
    'x-component': Row,
    'x-component-props': {
      gutter: 20
    },
    properties: {
      frontOcrCol: {
        type: 'void',
        'x-component': Col,
        properties: {
          [`
          {  
            ossId: legalPersonFrontOssId, 
            result: {
              name: legalPersonName,
              idNumber: legalPersonIdNumber
            }
          }
          `]: {
            type: 'object',
            'x-decorator': FormItem,
            'x-decorator-props': {
              wrapperWidth: 'auto'
            },
            'x-component': OcrIdCard.Front
          }
        }
      },
      backOcrCol: {
        type: 'void',
        'x-component': Col,
        properties: {
          [`
          {
            ossId: legalPersonBackOssId,
            result: {
              issueAuthority: legalPersonIssueAuthority
            }
          }
          `]: {
            type: 'object',
            'x-decorator': FormItem,
            'x-decorator-props': {
              wrapperWidth: 'auto'
            },
            'x-component': OcrIdCard.Back
          }
        }
      }
    }
  },
  legalPersonName: {
    title: '法人姓名',
    type: 'string',
    'x-pattern': 'readPretty',
    'x-decorator': FormItem,
    'x-component': Input
  },
  legalPersonIdNumber: {
    title: '法人身份证号',
    type: 'string',
    'x-pattern': 'readPretty',
    'x-decorator': FormItem,
    'x-component': Input
  }
}
